"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockPriceFeed = void 0;
var ethers_1 = require("ethers");
var EvmPriceSigner_1 = __importDefault(require("redstone-node/dist/src/signers/EvmPriceSigner"));
var DEFAULT_TIMESTAMP_DIFF = 5000;
var MockPriceFeed = /** @class */ (function () {
    function MockPriceFeed(initialMock) {
        this.priceSigner = new EvmPriceSigner_1.default();
        this.signer = new ethers_1.Wallet(MockPriceFeed.P_KEY);
        this.mock = this.mock.bind(this);
        this._mockedPricePackage = initialMock;
    }
    MockPriceFeed.prototype.getSignedPrice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentTime, pricePackage, signedPackage, serializedPackage;
            return __generator(this, function (_a) {
                currentTime = Math.round(new Date().getTime());
                if (typeof this._mockedPricePackage == "function") {
                    pricePackage = this._mockedPricePackage(currentTime);
                }
                else {
                    pricePackage = this.convertPriceObjectToPricePackage(this._mockedPricePackage, currentTime);
                }
                signedPackage = this.priceSigner.signPricePackage(pricePackage, this.signer.privateKey);
                serializedPackage = this.priceSigner.serializeToMessage(pricePackage);
                return [2 /*return*/, {
                        priceData: serializedPackage,
                        signer: signedPackage.signer,
                        signature: signedPackage.signature,
                        liteSignature: signedPackage.liteSignature
                    }];
            });
        });
    };
    MockPriceFeed.prototype.convertPriceObjectToPricePackage = function (priceObject, currentTime) {
        var prices = [];
        for (var _i = 0, _a = Object.entries(priceObject); _i < _a.length; _i++) {
            var _b = _a[_i], symbol = _b[0], value = _b[1];
            prices.push({ symbol: symbol, value: value });
        }
        return {
            prices: prices,
            timestamp: currentTime - DEFAULT_TIMESTAMP_DIFF,
        };
    };
    MockPriceFeed.prototype.getSigner = function () {
        var wallet = new ethers_1.Wallet(MockPriceFeed.P_KEY);
        return Promise.resolve(wallet.address);
    };
    MockPriceFeed.prototype.mock = function (value) {
        this._mockedPricePackage = value;
    };
    MockPriceFeed.P_KEY = "0xae2b81c1fe9e3b01f060362f03abd0c80a6447cfe00ff7fc7fcf000000000000";
    return MockPriceFeed;
}());
exports.MockPriceFeed = MockPriceFeed;
//# sourceMappingURL=MockPriceFeed.js.map